export default "__VITE_ASSET__npxL4eWXIJH5QABfLaSn4g__"